import { render } from "./FailedBookingInfo.vue?vue&type=template&id=d1f1ae0e&scoped=true"
import script from "./FailedBookingInfo.vue?vue&type=script&lang=js"
export * from "./FailedBookingInfo.vue?vue&type=script&lang=js"

import "./FailedBookingInfo.vue?vue&type=style&index=0&id=d1f1ae0e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f1ae0e"]])

export default __exports__